import {api} from '../../../system/api';

export default {
    getBagPackingDetail: (params) => api.get('bags/' + params.id + '/bagging-detail', {}, {singleRequest: true}),
};
